angular.module('impactx.productlabel').service('ProductLabel', [
    '$mdDialog',
    ProductLabel
]);

function ProductLabel($mdDialog) {
    var self = this;

    self.openInfoText = function (event, productLabelId) {
        return $mdDialog.show({
            multiple: true,
            templateUrl: 'modules/productlabel/templates/product-label-info-text.dialog.html',
            controller: 'ProductLabelInfoTextDialogCtrl',
            controllerAs: "ctrl",
            bindToController: true,
            fullscreen: false,
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                productLabelId: productLabelId
            }
        });
    };

    return {
        openInfoText: self.openInfoText
    };
}